import { PUBLIC_HOST_RESERVED_PATHS } from "./public-host-paths";
export const RESERVED_PUBLIC_DASHBOARD_SLUGS = PUBLIC_HOST_RESERVED_PATHS;
const RESERVED_SET = new Set(RESERVED_PUBLIC_DASHBOARD_SLUGS);
export function isReservedPublicDashboardSlug(slug) {
    return RESERVED_SET.has(slug.toLowerCase());
}
